import installationInstructions from './installationInstructions';

const pemPlugContent = {
  installationInstructions
}

export { pemPlugContent };
